<template>
  <div>
    <div v-if="uploadFiles.length > 0" class="uploaded-files-position">
      <div v-for="(file, index) in uploadFiles" :key="index" class="uploaded-delate-box-position">
        <template v-if="checkImage(file.type)">
          <b-tooltip :label="file.name" :append-to-body="true" :delay="500">
            <div class="uploaded-files-container">
              <img :src="file.path" alt="" class="">
            </div>
          </b-tooltip>
          <button class="delete-button" @click="deleteFile(file.UID)">
            <b-icon type="is-black" class="collapse-icon" icon="reset" />
          </button>
        </template>
        <template v-else>
          <b-tooltip :label="file.name" :append-to-body="true" :delay="500">
            <div
              class="uploaded-files-container"
              :style="`background-color: ${getColor(file.name).bgColor};`"
            >
              <div class="uploaded-files-header">
                <h3 :style="`color: ${getColor(file.name).color}`">
                  {{ file.name.split('.').pop().toUpperCase() }}
                </h3>
              </div>
              <div class="uploaded-files-body">
                <p>{{ file.name }}</p>
              </div>
            </div>
          </b-tooltip>
          <button class="delete-button" @click="deleteFile(file.UID)">
            <b-icon type="is-black" class="collapse-icon" icon="reset" />
          </button>
        </template>
        <!-- <div v-if="file.type.includes('application')">
          <b-tooltip :label="file.name" :append-to-body="true" :delay="500">
            <div
              class="uploaded-files-container uploaded-files-container-padding "
              :style="`background-color: ${getColor(file.name).bgColor};`"
            >
              <div class="uploaded-files-header">
                <h3 :style="`color: ${getColor(file.name).color}`">
                  {{ file.name.split('.').pop().toUpperCase() }}
                </h3>
              </div>
              <div class="uploaded-files-body">
                <p>{{ file.name }}</p>
              </div>
              <button class="delete-button" @click="deleteFile(file.UID)">
                <b-icon type="is-black" class="collapse-icon" icon="reset" />
              </button>
            </div>
          </b-tooltip>
        </div>
        <div v-else-if="file.type.includes('image')">
          <template v-if="checkImage(file.type)">
            <img :src="file.path" alt="" class="uploaded-files-container">
            <button class="delete-button" @click="deleteFile(file.UID)">
              <b-icon type="is-black" class="collapse-icon" icon="reset" />
            </button>
          </template>
          <template v-else>
            po prostu plik
          </template>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewMessengerConversationUploadedFiles',
  props: {
    uploadFiles: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      active: true,
      extensionColors: {
        docx: {
          color: '#46A5EE',
          bgColor: '#C7E4FA'
        },
        doc: {
          color: '#46A5EE',
          bgColor: '#C7E4FA'
        },
        xls: {
          color: '#25A366',
          bgColor: '#A6DAC2'
        },
        xlsx: {
          color: '#25A366',
          bgColor: '#A6DAC2'
        },
        rar: {
          color: '#EAA627',
          bgColor: '#FBDFAC'
        },
        zip: {
          color: '#EAA627',
          bgColor: '#FBDFAC'
        },
        pdf: {
          color: '#E33032',
          bgColor: '#F9D4D4'
        },
        file: {
          color: '#909091',
          bgColor: '#D5D5D5'
        }
      }
    }
  },

  methods: {
    getColor (file) {
      const extension = file.split('.').pop().toLowerCase()
      if (this.extensionColors[extension]) {
        return this.extensionColors[extension]
      } else {
        return this.extensionColors.file
      }
    },
    deleteFile (index) {
      this.$emit('delete-file', index)
    },
    checkImage (type) {
      const typicalImages = ['jpeg', 'png', 'webp', 'gif']
      return !!typicalImages.some(image => type.includes(image))
    }
  }

}
</script>
<style lang="scss" scoped>
.uploaded-files-position {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  max-height: 100px;
  padding: 8px;
  overflow-y: auto;
}

.uploaded-delate-box-position {
  position: relative;
  display: flex;
  align-items: center;
  width: 60px;
  height: 60px;
  &:hover {
    .delete-button {
      opacity: 1;
      transform: translateY(-5px);
    }
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  .delete-button {
    display: block;
    position: absolute;
    top: -5px;
    left: 45px;
    width: 10px;
    height: 10px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s, transform 0.3s;
    z-index: 101;
    i {
      font-size: 12px;
    }
  }
}

.uploaded-files-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  text-align: center;
  border-radius: 10px;
}
.uploaded-files-header {
  width: 100%;

  h3 {
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.uploaded-files-body {
  width: 100%;
  padding: 0 6px;
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 10px;
  }
}
.uploaded-picture-container {
  width: 60px;
  height: 60px;

  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
}
</style>
